"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var clamp_text_1 = tslib_1.__importDefault(require("../../../../../../common/components/clamp-text/clamp-text"));
var description_scss_1 = tslib_1.__importDefault(require("./description.scss"));
var CardDescription = function (_a) {
    var _b;
    var text = _a.text, withSeparator = _a.withSeparator, isShrinkable = _a.isShrinkable, liveLabel = _a.liveLabel;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(description_scss_1.default.container, (_b = {},
            _b[description_scss_1.default['with-separator']] = withSeparator,
            _b[description_scss_1.default['is-shrinkable']] = isShrinkable,
            _b[description_scss_1.default['with-live-label']] = Boolean(liveLabel),
            _b)) },
        liveLabel && react_1.default.createElement("span", { className: description_scss_1.default.live }, liveLabel),
        react_1.default.createElement(clamp_text_1.default, { text: text, dataHook: "action-card-title" })));
};
CardDescription.propTypes = {
    text: prop_types_1.default.string,
    withSeparator: prop_types_1.default.bool,
    isShrinkable: prop_types_1.default.bool,
    liveLabel: prop_types_1.default.string,
};
exports.default = CardDescription;
//# sourceMappingURL=description.js.map